export interface AttachmentCard {
  archived?: boolean;
  /**
   * @deprecated Será pego automaticamente do caminho do arquivo.
   */
  extension?: AttachmentExtension;
  fileUrl: string;
  id: string;
  subtitle?: string;
  title: string;
}

/**
 * @deprecated Será pego automaticamente do caminho do arquivo.
 */
export enum AttachmentExtension {
  CSV = 'csv',
  DOC = 'doc',
  DOCX = 'docx',
  JPEG = 'jpeg',
  JPG = 'jpg',
  MOV = 'mov',
  MP4 = 'mp4',
  ODS = 'ods',
  OGG = 'ogg',
  PDF = 'pdf',
  PNG = 'png',
  PPT = 'ppt',
  PPTX = 'pptx',
  TXT = 'txt',
  WEBM = 'webm',
  XLS = 'xls',
  XLSX = 'xlsx',
}
